import { useState } from 'react';

import type { WithdrawalAccount } from 'api';

import { PrimaryButton } from '@atoms/buttons/PrimaryButton';
import { WithdrawFundsIcon } from '@atoms/Icon/WithdrawFundsIcon';

import { WITHDRAW_FUNDS_BUTTON } from './constants';
import { WithdrawalRequestDialog } from './WithdrawalRequestDialog';

type Props = {
  withdrawalAccounts: WithdrawalAccount[];
  isWithdrawalAccountsError: boolean;
  isWithdrawalAccountsLoading: boolean;
};

export const CreateWithdrawalButton = ({
  withdrawalAccounts,
  isWithdrawalAccountsError,
  isWithdrawalAccountsLoading
}: Props) => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <PrimaryButton
        className="flex h-10 items-center gap-2"
        onClick={() => setOpen(true)}
        size="large"
        data-testid={WITHDRAW_FUNDS_BUTTON}
      >
        <WithdrawFundsIcon className="size-5" stroke="black" />
        Withdraw funds
      </PrimaryButton>
      <WithdrawalRequestDialog
        open={open}
        onClose={() => setOpen(false)}
        withdrawalAccounts={withdrawalAccounts}
        isWithdrawalAccountsError={isWithdrawalAccountsError}
        isWithdrawalAccountsLoading={isWithdrawalAccountsLoading}
      />
    </>
  );
};
